import MainLayout from "@/components/layout/applicant/MainLayout.vue";

export default {
    name: "expiredToken",
    components: {
        MainLayout
    },
    data() {
        return {
            homeRoute: { name: "homeIndex" },
            forgetPasswordRoute: { name: "applicantForgetPassword" }
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.path.startsWith('/company')) {
                vm.homeRoute = { name: 'companyIndex' };
                vm.forgetPasswordRoute = { name: 'companyForgetPassword' };
            } else if (from && from.path) {
                if (from.path.startsWith('/company')) {
                    vm.homeRoute = { name: 'companyIndex' };
                    vm.forgetPasswordRoute = { name: 'companyForgetPassword' };
                }
            }
        });
    }
};